export function darkenColor(color, amount) {
  color = color === 'transparent' ? '#e8e8e8': color;
  const rgbColor = hexToRgb(color);
  const darkenedRgbColor = {
    r: Math.max(rgbColor.r - Math.floor(amount * 255), 0),
    g: Math.max(rgbColor.g - Math.floor(amount * 255), 0),
    b: Math.max(rgbColor.b - Math.floor(amount * 255), 0),
  };
  return rgbToHex(darkenedRgbColor);
}

export function hexToRgb(hex) {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return { r, g, b };
}

export function rgbToHex(color) {
  const { r, g, b } = color;
  const hexR = r.toString(16).padStart(2, '0');
  const hexG = g.toString(16).padStart(2, '0');
  const hexB = b.toString(16).padStart(2, '0');
  return `#${hexR}${hexG}${hexB}`;
}

// 当前盘面转为“填写+题目”
// 数组[[e0,k1,t2,e0,e0,e0,t2,t4,t5],[...],...]
// k表示填写，t表示题目
export function timuKoArray(tt){
  const arr=[]
  for(let i=0;i<81;i++){
    const r=i/9|0;
    const c=i%9;
    arr[r]=arr[r]||[];
    const shh=tt[i].sh*1;
    if (shh===0){
      arr[r][c]='e0';
    }else if (shh===1){
      const num=tt[i].nu[shh-1];
      arr[r][c]='t'+num[1];
    }else if(shh===2){
      const num=tt[i].nu[shh-1];
      arr[r][c]='k'+num[1];
    }else if(shh===3){
      const n=numScA(tt[i].sc);
      if(n!==0){
        arr[r][c]='k'+n
      }else{
        arr[r][c]='e0';
      }
    };
  };
  return arr;
}

// 当前盘面转为“候选+填写+题目”
// 数组[[e0,k1,t2,h3456789,e0,e0,t2,t4,t5],[...],...]
// k表示填写，t表示题目
export function timuHxArray(tt){
  const arr=[]
  for(let i=0;i<81;i++){
    const r=i/9|0;
    const c=i%9;
    arr[r]=arr[r]||[];
    const shh=tt[i].sh*1;
    if (shh===0){
      arr[r][c]='e0';
    }else if (shh===1){
      const num=tt[i].nu[shh-1];
      arr[r][c]='t'+num[1];
    }else if(shh===2){
      const num=tt[i].nu[shh-1];
      arr[r][c]='k'+num[1];
    }else if(shh===3){
      const num=tt[i].nu[shh-1].match(/\d/g).join('');
      arr[r][c]='h'+num;
      const n=numScA(tt[i].sc);
      if(n!==0){
        arr[r][c]='k'+n
      }else{
        tt[i].sc.forEach((v,id)=>{
          if(v[0]==='a'){
            arr[r][c]=arr[r][c].replace(''+(id+1),'')
          }
        })
      }
    };
  };
  return arr;
}

// 行方向：['012000245',...]
export function tikoRow(tiko){
  return  tiko.map((value)=>{
    return value.toString().replace(/[etk]/g,'').replace(/[,]/g,'')
  })
}

// 把源数据转为字符数组
// [['e0','k1','t2','e0','e0','e0','t2','t4','t5'],[...],...]转化为
// 列方向：['040005000',...]
export function tikoCol(tiko){
  const arr=[]
  for(let j=0;j<9;j++){
    let str=''
    for(let i=0;i<9;i++){
      str += tiko[i][j].slice(1)
    }
    arr.push(str)
  }
  return arr
}


// 把源数据转为字符数组
// [['e0','k1','t2','e0','e0','e0','t2','t4','t5'],[...],...]转化为
// 宫方向：['079420000',...]
export function tikoBox(tiko){
  const arr=[]
  for (let row = 0; row < 3; row++) {
  for (let col = 0; col < 3; col++) {
    let str='';
    for (let r = 0; r < 3; r++) {
    for (let c = 0; c < 3; c++) {
      const i = row * 3 + r;
      const j = col * 3 + c;
      str += tiko[i][j].slice(1);
    }}
    arr.push(str)
  }}
  return arr
}


// 当前格子的候选数
// 返回候选数字符串
export function rcHxNum(rowArr,colArr,boxArr,r,c){
  let num='';
  const b=(r/3|0)*3+c/3|0;
  const str=rowArr[r]+colArr[c]+boxArr[b];
  for(let n=1;n<=9;n++){
    if(!str.includes(n)){
      num+=n
    }
  }
  return num
}


// 判断盘面填满了候选数，填满了为true
export function isAllCandidate(tt){
  const tihx=timuHxArray(tt)

  for(let i=0;i<9;i++){
    for(let j=0;j<9;j++){
      if(tihx[i][j]==='e0'){
        return false
      }
    }
  }
  return true
}

// 返回单元格候选数背景色选“是”的数字,如果没有返回0
export function numScA(sc){
  for(let i=0;i<9;i++){
    if(sc[i][0]==='b'){
      return i+1;
    }
  }
  return 0;
}

// 把候选数背景色填写情况成一个数组
export function toScArray(tt){
  return tt.map(v=>[...v.sc,v.nu[2].match(/\d/g).join('').replace(/0/g,'')])
}